import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';
import {SEARCH_FORM_ACTION_LOCATION} from '../../../utils/edap';

import {useOptions} from './useOptions';

const defaultEdapOptions = {
    searchSubmitEventActionLocation: SEARCH_FORM_ACTION_LOCATION,
    searchSubmitEventAppData: undef,
    searchQuerySubmittedEventActionLocation: SEARCH_FORM_ACTION_LOCATION,
    destinationSummaryClickEventAction: undef,
    destinationSummaryClickEventCategory: undef,
    submitSummaryClickEventAction: undef,
    submitSummaryClickEventCategory: undef,
    detailsModalCloseEventAction: undef,
    detailsModalCloseEventCategory: undef
};

const fixedEdapOptions = {
    searchSubmitEventName: 'search.submit',
    datedSearchSubmitEventName: 'dated.search.submit',
    searchQuerySubmittedEventName: 'search_query.submitted'
};

function useEdapOptions(props) {
    const {
        edapOptions: propsEdapOptions
    } = props;

    const {
        options: edapOptions
    } = useOptions(defaultEdapOptions, propsEdapOptions, fixedEdapOptions);

    const result = {
        edapOptions
    };

    useDebugValue(result);

    return result;
}

export {useEdapOptions};
